export default __webpack_public_path__ + "static/background-422dd66f28a23a535d45f13554a196cd.jpg";